import { render } from "./BaseTablePageTools.vue?vue&type=template&id=54289f44"
import script from "./BaseTablePageTools.vue?vue&type=script&lang=js"
export * from "./BaseTablePageTools.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__